export const urlGetPenyusutan = "/wmsAsset/despresiasi/listdepresiasi-id";

export const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "center",
  },
  {
    id: "id",
    disablePadding: false,
    label: "ID",
    align: "center",
  },
  {
    id: "name",
    disablePadding: false,
    label: "NAMA ASSET",
    align: "left",
    minWidth: "200px",
  },
  {
    id: "id_fixed_asset",
    disablePadding: false,
    label: "ID FIXED ASSET",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "id_fixed_asset",
    disablePadding: false,
    label: "IDGL",
    align: "left",
    minWidth: "100px",
  },
  {
    id: "jumlah",
    disablePadding: false,
    label: "JUMLAH",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "tanggal",
    disablePadding: false,
    label: "TANGGAL",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "remark",
    disablePadding: false,
    label: "REMARK",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "inserted_time",
    disablePadding: false,
    label: "INSERTED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "inserted_by",
    disablePadding: false,
    label: "INSERTED BY",
    sort: false,
    minWidth: "150px",
  },
];
